import { useOutletContext, useLocation } from 'react-router-dom';
import { CarHealthView } from './CarHealthView';
import { CarSwitchingSimulator } from './CarSwitchingSimulator';

type RepairAnalysisProps = {
  car: any;
  logEntries: any[];
  isReadOnly: boolean;
  initialView?: 'health' | 'switch';
  compact?: boolean;
};

export function RepairAnalysis({ car, logEntries, isReadOnly, initialView, standalone, onStatusUpdate, compact }: RepairAnalysisProps & { standalone?: boolean, onStatusUpdate?: (status: { score: number; recommendation: string }) => void }) {
  const context = useOutletContext<any>() || {};
  
  const effectiveCar = standalone ? { id: 'simulator', fuel_type: 'petrol' } : (car || context.selectedCar);
  const effectiveLogEntries = standalone ? [] : (logEntries || context.logEntries || []);
  const effectiveIsReadOnly = standalone ? false : isReadOnly;
  const { setActiveTab } = context;
  
  const location = useLocation();

  // Determine view: explicit prop takes precedence, then path, then default
  const view = initialView || (location.pathname.includes('/switch') ? 'switch' : 'health');

  const handleBackToHealth = () => {
    if (setActiveTab) {
      setActiveTab('repair');
    }
  };

  if (view === 'switch') {
    return (
      <CarSwitchingSimulator 
        car={effectiveCar} 
        logEntries={effectiveLogEntries} 
        isReadOnly={effectiveIsReadOnly}
        onBackToHealth={handleBackToHealth} 
      />
    );
  }

  return (
    <CarHealthView 
      car={effectiveCar} 
      logEntries={effectiveLogEntries} 
      isReadOnly={effectiveIsReadOnly} 
      onScoreUpdate={onStatusUpdate}
      compact={compact}
    />
  );
}
